module.exports = "query GetImages($offset: Int, $limit: Int) {\n  images(offset: $offset, limit: $limit) {\n    ...ImageFragment\n  }\n}\n"